<template>
  <div class="fullscrean text-muted">
    <div>
      <img src="../assets/logo-lecard.png" class="img-fluid" alt="Logo Lecard" style="width: 96px">
      <div class="mt-4">
        <div v-if="!load">
          <h5 class="mb-2 font-weight-bold">Atualize seu Bot</h5>
          <p class="mb-3" style="max-width: 550px">
            Sua versão atual está desatualizada.
            Clique em "Atualizar versão" para continuar ou em caso de dúvidas, entre em contato com o nosso suporte pelo WhatsApp: (16) 99453-3763.
          </p>
          <button class="btn btn-primary px-4" @click="atualizar()" :disabled="load">
            {{ load ? 'Baixando a versão..' : 'Atualizar versão' }}
          </button>
          <div class="d-flex justify-content-center small mt-4">
            <div>Web: <b>{{ app_version }}</b></div>
            <div v-if="isElectron"><span class="mx-2">|</span>Desktop: <b>{{ version }}</b></div>
          </div>
        </div>
        <div v-else>
          <h5 class="mb-2 font-weight-bold">{{ update.title }}</h5>
          <p class="mb-3" style="max-width: 550px">{{ update.mensagem }}</p>
          <loading v-if="update.step < 2" />
          <div class="mt-4 mx-auto text-center" v-else-if="update.step === 2" style="width: 260px">
            <div class="progress mb-2">
              <div class="progress-bar bg-primary" role="progressbar"
                   :aria-valuenow="update.progress" aria-valuemin="0" aria-valuemax="100"
                   :style="`width:${update.progress}%`">
              </div>
            </div>
            {{ update.progress | percent }}%
          </div>
          <button class="btn btn-outline-success px-4" v-else-if="update.step === 4" @click="atualizar()">Tentar novamente</button>
          <a href="/" class="btn btn-outline-success px-4" v-else-if="update.step === 5">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/commons/TopBar";
import Loading from "@/components/commons/Loading";

export default {
  name: 'Version',
  components: { Loading, TopBar },

  data() {
    return {
      load: false
    };
  },

  methods: {
    atualizar() {
      this.load = true;
      this.$store.commit('SET_UPDATE_PROGRESS', 0);
      this.$store.commit('SET_UPDATE_REPLY', {
        message: 'Verificando atualização',
        detail: 'Por favor aguarde.',
        step: 0
      });

      if (this.isElectron) {
        if (parseInt(this.version.replace(/[^0-9]/g, '')) < 142) {
          this.$store.commit('SET_UPDATE_REPLY', {
            message: 'Para atualizar sua versão',
            detail: 'Clique no menu "Ajuda" e depois em "Verificar atualizações"',
            step: 3
          });

        } else {
          window.control.update();
        }
      }
    }
  },

  created() {
    if (this.isElectron) {
      window.control.onUpdateReply((data) => {
        this.$store.commit('SET_UPDATE_REPLY', data || {});
      });

      window.control.onUpdateProgress((data) => {
        this.$store.commit('SET_UPDATE_PROGRESS', data || 0);
      });
    }
  },

  computed: {
    version() {
      return this.$store.state.version;
    },

    update() {
      return this.$store.state.update;
    }
  }
};
</script>

<style scoped>
</style>
